import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const accountsInvoiceDetails = createAsyncThunk('accounts_invoice/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `account_control/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addAccountsInvoice = createAsyncThunk('accounts_invoice/add', async (data) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "premise_id", data?.values?.premise || ''
    )
    bodyFormData.append(
        "invoicing_name", data?.values?.invoicingName || ''
    )
    bodyFormData.append(
        "invoice_logo", data?.values?.invoiceLogo || ''
    )
    bodyFormData.append(
        "prefix_code", data?.values?.invoicePrefix || ''
    )
    bodyFormData.append(
        "gst", data?.values?.gst || ''
    )
    bodyFormData.append(
        "pincode", data?.values?.pincode || ''
    )
    bodyFormData.append(
        "address", data?.values?.address || ''
    )
    bodyFormData.append(
        "invoice_conditions", data?.values?.terms_and_conditions || ''
    )

    data?.values?.dueDate && (
        bodyFormData.append(
            "DD", JSON.stringify(data?.values?.dueDate)
        )
    )

    data?.values?.taxes && (
        bodyFormData.append(
            "Tax", JSON.stringify(data?.values?.taxes)
        )
    )

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'account_control',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "invoice_logo", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const accountsInvoice = createSlice({
    name: 'accounts_invoice',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(accountsInvoiceDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default accountsInvoice.reducer;